<script setup lang="ts">
import type { ButtonProps } from '#layers/ui/components/Button.vue';
import { reactiveOmit } from '@vueuse/core';
import { useAppConfig } from '#app/config';
import DButtonDestructive from '#layers/ui/components/Button/Destructive.vue';

defineOptions({
	name: 'ButtonRemove',
});

const props = withDefaults(defineProps<{
	withLeadingIcon?: boolean;
	trashBin?: boolean;
} & Partial<ButtonProps>>(), {
	trashBin: true,
	size: 'sm',
	// Otherwise both are set to `false` and NuxtLink will detect a conflict
	prefetch: undefined,
	noPrefetch: undefined,
});

const appConfig = useAppConfig();
const forward = reactiveOmit(props, 'withLeadingIcon', 'trashBin');
</script>

<template>
	<DButtonDestructive
		v-bind="forward"
		:leading-icon="withLeadingIcon ? trashBin ? appConfig.ui.icons.trash : appConfig.ui.icons.close : undefined"
		:aria-label="props.label ?? $t('common.remove')"
	>
		<slot />
	</DButtonDestructive>
</template>
